import { Component, OnInit, Input, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { AutomotricesService } from '../../../../../services/creditos/automotrices.service';
/*App imports*/
import { HelpersService } from '../../../../../services/tools/helpers.service';

@Component({
  selector: 'automotriz-avaluo',
  templateUrl: './automotriz-avaluo.component.html'
})
export class AutomotrizAvaluoComponent implements OnInit {

    @Input() public idClientes: number = null;
    @Input() public idCreditos: number = null;
    @Input() public isCompleted: boolean = false;
    @Input() public isEditable: boolean = false;
    @Output() public onDataUpdated:EventEmitter<string> = new EventEmitter;
    //Cliente form
    public errors:any = {};
    public automotriz : any = {};
    public automotrizTotals : any = {};
    private isInitialized : boolean = false;
    //Deducciones
    public facturas : any = { porcentaje : null, valor : null};
    public endosos : any = { porcentaje : null, valor : null};
    public kilometraje : any = { porcentaje : null, valor : null};
    public fisicoInteriores : any = { porcentaje : null, valor : null};
    public fisicoExteriores : any = { porcentaje : null, valor : null};
    public foranidadFactura : any = { porcentaje : null, valor : null};
    public juegoLlaves : any = { porcentaje : null, valor : null};

    constructor(
      private helperService: HelpersService,
      private automotricesService : AutomotricesService,
    ){
    }

    public ngOnInit() {
    }

    public ngOnChanges(changes: SimpleChanges) {
    }

    public loadComponent(){
      if(!this.isInitialized){
        this.getCredito(this.idCreditos);    
        this.isInitialized = true;
      }
    }

    private getCredito(idCredito){
      
      //TODO: Manejar cuando el id no retorna un crédito valido
      this.automotricesService.get(idCredito).subscribe(
        (response)=>
        {
          const result = response.json().content;
          this.automotriz = result.automotriz;
          //Recalcular las deducciones
          this.changePrecioCompra();
          
          
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
          
          if(error.status == 400) {
            this.helperService.setBackendErrors(error.json().content, this.errors);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
    }

    public changePrecioCompra()
    {
      //TODO: Validar que los campos estén llenos
      let newPrice = this.automotriz.precio_compra;
      //Los cálculos dependen que ya se haya definido el precio del libro Azul
      if(!newPrice){
        return false;
      }
      //Aplicar el 25% de descuento
      let prestamoTotal = (newPrice * (this.automotriz.porcentaje_avaluo / 100));
      this.automotrizTotals.porcentajeTotal = prestamoTotal;
      
      //1. Aplicar deducción de Facturas
      this.facturas.porcentaje = this.automotriz.numero_facturas * 5;
      prestamoTotal = prestamoTotal - (prestamoTotal * (this.facturas.porcentaje / 100));
      this.facturas.valor = prestamoTotal;

      //2. Aplicar deducción de Endosos
      this.endosos.porcentaje = this.automotriz.numero_endosos * 3;
      prestamoTotal = prestamoTotal - (prestamoTotal * (this.endosos.porcentaje / 100));
      this.endosos.valor = prestamoTotal;

      //3. Aplicar deducción de Kilomentraje
      this.kilometraje.porcentaje = this.automotriz.ajuste_kilometraje ;
      //Lo multiplico por -1 para que si el valor seleccionado es negativo haga una deducción  y si es positivo haga una adición
      prestamoTotal = prestamoTotal - (prestamoTotal * (this.kilometraje.porcentaje / 100) * -1);
      this.kilometraje.valor = prestamoTotal;

      //4. Aplicar deducción de Edo físico interior
      //Lo multiplico por -1 para que si el valor seleccionado es negativo haga una deducción
      this.fisicoInteriores.porcentaje = this.automotriz.fisico_interiores * -2;
      prestamoTotal = prestamoTotal - (prestamoTotal * (this.fisicoInteriores.porcentaje / 100) );
      this.fisicoInteriores.valor = prestamoTotal;

      //5. Aplicar deducción de Edo físico exterior
      //Lo multiplico por -1 para que si el valor seleccionado es negativo haga una deducción
      this.fisicoExteriores.porcentaje = this.automotriz.fisico_exteriores * -2;
      prestamoTotal = prestamoTotal - (prestamoTotal * (this.fisicoExteriores.porcentaje / 100));
      this.fisicoExteriores.valor = prestamoTotal;

      //6. Aplicar deducción de Foranidad de la factura
      this.foranidadFactura.porcentaje = this.automotriz.factura_agencia * 2;
      prestamoTotal = prestamoTotal - (prestamoTotal * (this.foranidadFactura.porcentaje / 100));
      this.foranidadFactura.valor = prestamoTotal;

      //6. Aplicar deducción del juego de llaves
      this.juegoLlaves.porcentaje = this.automotriz.juego_llaves * 2;
      prestamoTotal = prestamoTotal - (prestamoTotal * (this.juegoLlaves.porcentaje / 100));
      this.juegoLlaves.valor = prestamoTotal;

      prestamoTotal = prestamoTotal - this.automotriz.tenencias;

      prestamoTotal = prestamoTotal - this.automotriz.presupuesto_reparacion;

      this.automotrizTotals.prestamoTotal = prestamoTotal;
      
    }

}



// WEBPACK FOOTER //
// ./src/app/creditos/automotriz/detalles/components/avaluo/automotriz-avaluo.component.ts